import { TextTestID } from "@/constants/TestID";
import { FAIconName, Icon } from "@/ui/core";
import type { AvatarCardProps } from "@/ui/core/AvatarCard";
import AvatarCard from "@/ui/core/AvatarCard";
import type { BaseCardProps } from "@/ui/layout";
import { BaseCard, Box, HStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface PressableAvatarCardProps extends ViewWithTestID {
  onPress: BaseCardProps["onPress"];
  userId: AvatarCardProps["userId"];
  userName: AvatarCardProps["userName"];
  userType: AvatarCardProps["userType"];
}

const PressableAvatarCard = ({
  onPress,
  testID,
  userId,
  userName,
  userType,
}: PressableAvatarCardProps) => {
  const baseTestID = joinTestIDs(
    testID,
    TextTestID.PressableAvatarCard,
    userId,
  );
  return (
    <BaseCard onPress={onPress} testID={baseTestID} variant="secondary">
      <HStack alignItems="center" gap={8} justifyContent="space-between">
        <Box flexGrow={1} flexShrink={1}>
          <AvatarCard
            isHorizontal={false}
            shouldShowSubtitle={false}
            userId={userId}
            userName={userName}
            userType={userType}
          />
        </Box>
        <Icon
          color={ColorToken.ButtonPrimaryActive}
          name={FAIconName.ArrowRight}
          size="md"
          testID={joinTestIDs(baseTestID, "arrow")}
        />
      </HStack>
    </BaseCard>
  );
};

export type { PressableAvatarCardProps };
export default PressableAvatarCard;
